module.exports = __webpack_public_path__ + "media/images/mechanics-title-7a17d77be72a0e7f3d0d1ef2cd79615d.svg";